module.exports = __webpack_public_path__ + "static/media/adm.57f1b6a9.png";